import { ProgramAPI } from '@/api'

const DefaultForm = function() {
  this.name = null;
  this.capacity = 100;
};


export default {
  namespaced: true,
  state: {
    form: new DefaultForm(),
    table: null,
  },
  mutations: {

    reset(state) {
      state.form = new DefaultForm();
      state.table = null;
    },

    setForm(state, form) {
      state.form = form;
    },

    setTable(state, data) {
      state.table = data;
    },
  },
  actions: {

    destroyState({ state, commit }) {
      commit('reset');
    },

    get({ state, commit, rootGetters }) {
      return ProgramAPI.getBlend(rootGetters['program/data'].id).then(res => {
        // console.log(res);
        if(res.data.form && res.data.table) {
          commit('setForm', res.data.form);
          commit('setTable', res.data.data);
        }
      });
    },

    calc({ state, commit, rootGetters }) {
      // console.log(state)
      return ProgramAPI.calcBlend({
        programId: rootGetters['program/data'].id,
        // blendName: state.form.name,
        blendName: 'Blend',
        containerCapacity: state.form.capacity,
      }).then(res => {
        const blend = res.data.data.Blend;

        let stages = blend.Stages;
        for(let stage in stages) {
          let blendToApply = 0;
          for(let num in stages[stage].Fertilizers) {
            blendToApply += stages[stage].Fertilizers[num].Concentration;
          }
          stages[stage].BlendToApply = blendToApply;
          blend.Stages = stages;
        }

        commit('setTable', blend);
      });
    },

    async save({ state, commit, rootGetters, dispatch }) {
      await ProgramAPI.saveBlend(rootGetters['program/data'].id, {
        form: state.form,
        table: state.table,
      });
      await dispatch('program/steps/setCurrentStep', 'blend', { root: true });
      // await dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'blend', { root: true });
    },
  },
  getters: {

    form(state) {
      return state.form
    },

    table(state) {
      return state.table;
    },
  }
};
